/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const QuantityQuality = {
    NotSpecified: 'NotSpecified',
    Estimated: 'Estimated',
    AsRead: 'AsRead',
    Revised: 'Revised',
    Calculated: 'Calculated',
} as const;
export type QuantityQuality = typeof QuantityQuality[keyof typeof QuantityQuality];

